import { Form, Button, Alert } from 'react-bootstrap';
import { connect } from 'react-redux';
import axiosInstance from '../general/axiosInstance';
import React, { useEffect, useState } from 'react';
import { setIsLoading } from '../general/actions';
import AlertModal from '../general/alertModal';
import DepartmentUsers from './departmentUsers';
import DepartmentsList from './departmentsList';

function Departments(props) {
    const { setIsLoading } = props;

    const [isCreation, setIsCreation] = useState(false);
    const [hasUsers, setHasUsers] = useState(false);

    const [alertModalShow, setAlertModalShow] = useState(false);
    const [alertModalMsg, setAlertModalMsg] = useState('');
    const [alertModalType, setAlertModalType] = useState('');
    const [alertModalOnConfirm, setAlertModalOnConfirm] = useState(null);
    const [alertModalOnClose, setAlertModalOnClose] = useState(null);

    const [idEdit, setIdEdit] = useState('');
    const [extId, setExtId] = useState('');
    const [name, setName] = useState('');
    const [isActive, setIsActive] = useState(true);

    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('warning');

    useEffect(() => {
        setMessageType('warning');
        setMessage(name === '' ? 'Centro de Costos es obligatorio' : '');
    }, [name]);

    useEffect(() => {
        if (isCreation) { setIdEdit(''); setName(''); setExtId(''); setIsActive(true); }
    }, [isCreation]);

    const getItemData = () => ({ ext_id: extId, name, is_active: isActive });

    const deleteItem = async (id, confirmed) => {
        if (!confirmed) {
            setAlertModalShow(true);
            setAlertModalMsg('¿Está seguro de eliminar el centro de costos ' + id + '?');
            setAlertModalOnConfirm(() => () => { deleteItem(id, true); });
            return;
        }
        setIsLoading(true);
        try {
            await axiosInstance.delete(`/departments/${id}`);
            setAlertModalShow(true);
            setAlertModalMsg('Centro de Costos eliminado correctamente');
            setAlertModalOnClose(() => () => { setIdEdit(''); setIsCreation(false); });
        } catch (error) {
            setAlertModalShow(true);
            setAlertModalType('danger');
            if (error.response.data.message.indexOf('Fund is used') > 0) {
                setAlertModalMsg('No es posible eliminar un centro de costos en uso');
            } else if (error.response.data.message.indexOf('user_funds_fund_id_foreign') > 0) {
                setAlertModalMsg('No es posible eliminar: tiene usuarios asignados');
            } else {
                setAlertModalMsg(error.message);
            }
        } finally { setIsLoading(false); }
    };

    const saveItem = async () => {
        try {
            if (isCreation) {
                await axiosInstance.post('/departments', getItemData());
                setIsCreation(false);
            } else {
                await axiosInstance.put(`/departments/${idEdit}`, getItemData());
                setIdEdit('');
            }
        } catch (error) {
            setMessageType('danger');
            setMessage(error.response.data.message.indexOf('Duplicate') > 0
                ? 'Centro de Costos ya existe' : error.message);
        } finally { setIsLoading(false); }
    };

    const setEditData = (row) => {
        setIdEdit(row.id); setName(row.name); setExtId(row.ext_id); setIsActive(row.is_active);
    };

    const isFormOpen = idEdit || isCreation;

    return (
        <>
            {!isFormOpen && (
                <DepartmentsList isCreation={isCreation} setIsCreation={setIsCreation} setEditData={setEditData} />
            )}

            {isFormOpen && (
                <>
                    <div className="order-page-header">
                        <div className="order-page-title">
                            <i className="fa fa-building-o" style={{ color: 'var(--abi-primary)' }} />
                            {idEdit ? `Modificar Centro de Costos #${idEdit}` : 'Crear Centro de Costos'}
                        </div>
                        {idEdit && (
                            <Button size="sm" variant="outline-danger" disabled={hasUsers} onClick={() => deleteItem(idEdit)}>
                                <i className="fa fa-trash" /> Eliminar
                            </Button>
                        )}
                    </div>

                    {hasUsers && (
                        <Alert variant="warning" className="py-2" style={{ fontSize: 13 }}>
                            No se puede eliminar: tiene usuarios asignados
                        </Alert>
                    )}

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 320px', gap: 16, alignItems: 'start' }}>
                        {/* Form */}
                        <div>
                            <div className="order-section">
                                <div className="order-section-header">
                                    <i className="fa fa-building-o" /> Datos del Centro de Costos
                                </div>
                                <div className="order-section-body">
                                    <Form.Label className="report-field-label">Nombre</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={name}
                                        placeholder="Nombre del centro de costos"
                                        onChange={(e) => setName(e.target.value)}
                                        className="mb-3"
                                    />
                                    <Form.Check
                                        type="switch" id="dept-active"
                                        label="Activo para pedidos nuevos"
                                        checked={isActive}
                                        onChange={(e) => setIsActive(e.target.checked)}
                                    />
                                    {message && (
                                        <Alert variant={messageType} className="py-2 mt-3" style={{ fontSize: 13 }}>
                                            {message}
                                        </Alert>
                                    )}
                                </div>
                            </div>

                            <div className="order-form-footer">
                                <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                                    <Button variant="outline-secondary" size="sm" onClick={() => { setIdEdit(''); setIsCreation(false); }}>
                                        <i className="fa fa-arrow-left" /> Volver
                                    </Button>
                                    <Button variant="primary" size="sm" onClick={saveItem} disabled={!!message}>
                                        <i className="fa fa-save" /> Guardar
                                    </Button>
                                </div>
                            </div>
                        </div>

                        {/* Sidebar users */}
                        <div className="order-section">
                            <div className="order-section-header"><i className="fa fa-users" /> Usuarios asignados</div>
                            <div className="order-section-body">
                                <DepartmentUsers department={idEdit} setHasUsers={setHasUsers} />
                            </div>
                        </div>
                    </div>
                </>
            )}

            <AlertModal
                show={alertModalShow} setShow={setAlertModalShow}
                msg={alertModalMsg} setMsg={setAlertModalMsg}
                onConfirm={alertModalOnConfirm} setOnConfirm={setAlertModalOnConfirm}
                onClose={alertModalOnClose} setOnClose={setAlertModalOnClose}
                variant={alertModalType}
            />
        </>
    );
}

function mapStateToProps(state) { return { isLoading: state.isLoading }; }
const mapDispatchToProps = { setIsLoading };
export default connect(mapStateToProps, mapDispatchToProps)(Departments);
